var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.updateExists)?_c('div',[_vm._v(" "+_vm._s(_vm.updateMessage)+" "),_c('button',{on:{"click":_vm.refreshApp}},[_vm._v("Confirm Update")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }